import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { Checkbox as s } from "@forma/forma-ui-kit";
const m = "forma-filling__fill-variation-answer__item", _ = "forma-filling__fill-variation-answer__itemDescription", f = "forma-filling__fill-variation-answer__itemCheckbox", h = "forma-filling__fill-variation-answer__checkboxIcon", i = {
  item: m,
  itemDescription: _,
  itemCheckbox: f,
  checkboxIcon: h
}, b = ({ id: o, name: n, description: e, selected: t, onSelect: c }) => /* @__PURE__ */ r("div", { className: i.item, children: [
  /* @__PURE__ */ a(
    s,
    {
      name: `variant_${o}`,
      label: n,
      containerClass: i.itemCheckbox,
      onChange: (l) => c(o, l.target.checked),
      checked: t,
      viewStyle: "square",
      iconClass: i.checkboxIcon
    }
  ),
  !!(e != null && e.length) && /* @__PURE__ */ a("div", { className: i.itemDescription, children: e })
] });
export {
  b as default
};
